import { useContext, useEffect, useState } from "react";
import { LoginContext } from "../context/LoginContext";
import {
  AdmissionDriveKind,
  resolveAdmissionDriveKind,
} from "../utils/applicationFlow";

export function useAdmissionDriveKind(): {
  kind: AdmissionDriveKind | null;
  driveName: string | null;
  loading: boolean;
  drive: any
  isDriveEditOpen: boolean
  isDriveOpen: boolean
  isAfterEditOpen: boolean
} {
  const { user } = useContext(LoginContext);
  const userId = user?.userId;
  const [kind, setKind] = useState<AdmissionDriveKind | null>(null);
  const [driveName, setDriveName] = useState<string | null>(null);
  const [drive, setDrive] = useState<any | null>(null);
  const [isDriveEdit, setIsDriveEditOpen] = useState<boolean>(false);
  const [isDriveOpen, setIsDriveOpen] = useState<boolean>(false);
  const [isAfterEditOpen, setIsAfterEditOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  

  const isDriveEditOpen = (startDateStr: string, endDateStr: string) => {
    if (!startDateStr) return false;
    if (!endDateStr) return false;
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today >= startDate && today <= endDate;
  };

  const isAfterDriveEditOpen = (endDateStr: string) => {
    if (!endDateStr) return false;
    const endDate = new Date(endDateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today >= endDate;
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!userId) {
        setKind(null);
        setDriveName(null);
        setDrive(null)
        setLoading(false);
        setIsDriveEditOpen(false)
        setIsDriveOpen(false)
        setIsAfterEditOpen(false)
        return;
      }
      setLoading(true);
      const activeDriveId = localStorage.getItem("activeDriveId");
      const r = await resolveAdmissionDriveKind(userId, activeDriveId);
      const editOpen = isDriveEditOpen(r.drive?.editstartdate, r.drive?.editenddate)
      const driveOpen = isDriveEditOpen(r.drive?.startdate, r.drive?.enddate)
      const afterEdit = isAfterDriveEditOpen(r.drive?.enddate)
      if (cancelled) return;
      setKind(r.kind);
      setDrive(r.drive);
      setIsDriveEditOpen(editOpen);
      setIsDriveOpen(driveOpen)
      setIsAfterEditOpen(afterEdit)
      setDriveName(r.driveName);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { kind, driveName, drive, loading, isDriveEditOpen: isDriveEdit, isDriveOpen, isAfterEditOpen };
}
